export default __webpack_public_path__ + "static/media/ug.463f178d.svg";